<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="700px" :zIndex='4100'
    @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="分类名称" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input v-decorator="rules.folderName"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    item: Object
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      confirmLoading: false,
      visible: false,
      ModalTitle: '添加分类',

      form: this.$form.createForm(this),
      rules: {
        folderName: [ 'folder_name',
          {rules: [{ required: true, message: '请输入分类名称!' }]}
        ],
      },
    }
  },

  async created() {
    this.visible = true
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { item, form } = this
        let params = await form.validateFields()
        if (params) {
          let res = await this.$store.dispatch('materialAjaxAddFolderAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.submitModal()
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideModal()
    }
  }
}
</script>
